import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: null,
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setProfile: (state, action) => {
      const profileData = action.payload;
      // Transform skills from comma-separated string to an array of values
      if (profileData.employeeSkill) {
        profileData.skills = profileData.employeeSkill
          .split(",")
          .map((skill) => skill.trim());
      } else {
        profileData.skills = [];
      }
      // Format birthDate to yyyy-MM-dd for the date input
      if (profileData.birthDate) {
        profileData.birthDate = profileData.birthDate.split("T")[0];
      }
      state.profile = profileData;
      state.error = null;
    },
    clearProfile: (state) => {
      state.profile = null;
    },
  },
});

export const { setLoading, setError, setProfile, clearProfile } =
  settingsSlice.actions;

export default settingsSlice.reducer;
